/**
 * שני בלוקי יעד קבועים במקום "חבילות נופש מומלצות" ו"טיולים מאורגנים".
 * סדר המערך = סדר המסילות: אתונה תמיד ראשונה; ברצלונה שנייה (עם נפילה לאתונה כשאין תוצאות).
 */
export const VP_ATHENS_SECOND_RAIL_COPY = {
  title: "חבילות נוספות — אתונה",
  subtitle: "מוצג כשאין זמינות לברצלונה — אותן חבילות מאתונה שלא הוצגו למעלה",
};

export const VP_FIXED_DESTINATION_SECTIONS = [
  {
    id: "dest_athens",
    cityCode: "ATH",
    title: "חבילות מומלצות — אתונה",
    subtitle: "טיסה ומלון לאתונה — לפי זמינות במערכת",
  },
  {
    id: "dest_barcelona",
    cityCode: "BCN",
    title: "חבילות מומלצות — ברצלונה",
    subtitle: "טיסה ומלון לברצלונה — לפי זמינות במערכת",
  },
];
